module.exports = __webpack_public_path__ + "static/media/lushan_plant.4f11a3b6.webp";